import React from 'react';
import { degreesIcon } from '@chordbaker/design';

interface DegreesIconProps {
  size?: number;
  color?: string;
}

type CircleElement = { cx: number; cy: number; r: number; strokeWidth?: number };
type TextElement = { x: number; y: number; fontSize: number; fontWeight?: string; content: string };

/** A circled "I" — the Degrees toggle glyph (shared definition in @chordbaker/design). */
const DegreesIcon: React.FC<DegreesIconProps> = ({ size = degreesIcon.defaultSize, color = 'currentColor' }) => {
  const circle = degreesIcon.elements[0] as unknown as CircleElement;
  const text = degreesIcon.elements[1] as unknown as TextElement;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={degreesIcon.viewBox} width={size} height={size} fill="none">
      <circle cx={circle.cx} cy={circle.cy} r={circle.r} stroke={color} strokeWidth={circle.strokeWidth ?? 2} fill="none" />
      <text
        x={text.x}
        y={text.y}
        fontSize={text.fontSize}
        fontWeight={text.fontWeight}
        textAnchor="middle"
        fill={color}
      >
        {text.content}
      </text>
    </svg>
  );
};

export default DegreesIcon;
